define(
  'marqueeTabsHandler',[
    'builderShowcaseObserver',
    'builderShowcaseHelper',
  ],
  (
    builderShowcaseObserver,
    showcaseHelper,
  ) => {
    'use strict';

    function marqueeTabsHandler() {
    }

    const tabSection = document.querySelector('[data-toggle-container]');

    const tabs = {
      map: 'map',
      gallery: 'gallery',
      video: 'video',
      tours: '3dTours'
    };

    /**
     * Method to retrieve the tab category from the event target.
     * @param {object} target event target
     */
    function getCategory(target) {
      return target.dataset ? target.dataset.buttonComponent : null;
    }

    /**
     * Method to require the the mapBuilderShowCase.js when the users clicks on locations/map tab.
     * @param {any} event
     */
    function loadMapResources(event) {
      const category = getCategory(event.target);
      if (category === tabs.map) {
        require(['mapBuilderShowcase']);
        tabSection.removeEventListener('click', loadMapResources);
      }
    }

    /**
     * Removes the classes and attributes set to the last active item
     */
    function cleanActiveElements() {
      const elements = document.querySelectorAll('[data-toggle-container] button');
      if (elements) {
        elements.forEach((element) => {
          const elementToEdit = element;
          elementToEdit.classList.remove('btn--active');
          elementToEdit.dataset.active = false;
        });
      }
    }

    /**
     * Apply styles to the active item and remove the old active ones.
     */
    function applyStyles(target) {
      const element = target;
      cleanActiveElements();
      element.classList.add('btn--active');
      element.dataset.active = true;
    }

    /**
      * Switches the view component on the marquee based on user action.
      * @param {} event
      */
    function switchMarqueeView(event) {
      const marqueeComponent = document.querySelectorAll('[data-marquee-component]');
      const category = getCategory(event.target);
      if (category) {
        marqueeComponent.forEach((component) => {
          component.setAttribute('hidden', true);
          if (component.dataset.marqueeComponent === category) {
            component.removeAttribute('hidden');
          }
        });
      }

      applyStyles(event.target);
    }

    /**
    * @private
    * getCollection: gets the collection of the selected image.
    */
    function getCollection(state, subCollection) {
      const data = state.data.galleryCollections;
      const parameter = `${subCollection.toLowerCase()}Collection`;
      return data[parameter];
    }

    /**
    * Private,
    * applyActiveStylesToCategory: applies the active styles to a category
     * from the marquee media options
    * @param {Object} data with the information from the active media element
    */
    function applyActiveStylesToCategory(data) {
      const activeCategory = document.querySelector('[data-button-component].btn--active');
      const selectedItemCategoryName = activeCategory.dataset.mediaType;
      const selectedCategoryName = data.HolderCollectionName;

      if (selectedItemCategoryName !== selectedCategoryName) {
        const categoryToSelect =
          document.querySelector(`[data-button-component][data-media-type="${selectedCategoryName}"`);
        activeCategory.classList.remove('btn--active');
        categoryToSelect.classList.add('btn--active');
      }
    }

    /**
    * Private,
    * scrollToActiveCategory: moves the filmstrip to a given category
    * @param {event} event with the information collected with the click
    */
    function scrollToActiveCategory(event) {
      const activeCategory = event.target.dataset.mediaType;
      const scroller = document.querySelector('[data-component="marquee-filmstrip"]');
      const elementToScrollTo = document.querySelector(`li[data-media-type="${activeCategory}"]`);
      const stateActiveElement = builderShowcaseObserver.getState();

      if (!stateActiveElement.data.activeImage) {
        return;
      }

      if (stateActiveElement.data.activeImage.marqueeGallery.HolderCollectionName === activeCategory) {
        builderShowcaseObserver.imageSelected(stateActiveElement.data.activeImage.marqueeGallery);
        return;
      }

      if (!elementToScrollTo) {
        const videoContainer = document.getElementById('nhs_VideoContainer');
        if (videoContainer) {
          videoContainer.parentNode.removeChild(videoContainer);
        }

        return;
      }

      const imageId = elementToScrollTo.querySelector('picture').dataset.imageId;
      const activeElement = showcaseHelper.getCollectionItem(imageId, activeCategory, getCollection);
      const activeImage = {};

      scroller.scrollTo({ left: elementToScrollTo.offsetLeft, top: 0, behavior: 'smooth' });
      showcaseHelper.applyActiveStyles(elementToScrollTo.querySelector('PICTURE'), '[data-filmstrip-image]');
      activeImage.marqueeGallery = activeElement;
      builderShowcaseObserver.setData({ activeImage });
      builderShowcaseObserver.commit();
      builderShowcaseObserver.imageSelected(activeElement);
    }

    /**
    * Private,
    * handleTabClick: listens to the click
    * @param {event} event with the information collected with the click
    */
    function handleTabClick(event) {
      if (!getCategory(event.target)) {
        return;
      }
      loadMapResources(event);
      switchMarqueeView(event);
      requestAnimationFrame(scrollToActiveCategory.bind(null, event));
    }

    /**
     * This method will create the events for the tabs component.
     */
    function handleTabChange() {
      if (tabSection) {
        tabSection.addEventListener('click', handleTabClick);
      }
    }

    marqueeTabsHandler.update = function loadLocationsTab(data, topic) {
      if (topic === 'onBeforeMapResultsLoaded') {
        const loctationsTab = document.querySelector('[data-button-component="map"]');

        if (!loctationsTab || loctationsTab.dataset.active === 'true') {
          return;
        }

        loctationsTab.click();
        return;
      }

      if (topic === 'onImageSelected') {
        applyActiveStylesToCategory(data);
      }
    };

    handleTabChange();
    builderShowcaseObserver.subscribe('onBeforeMapResultsLoaded', marqueeTabsHandler);
    builderShowcaseObserver.subscribe('onImageSelected', marqueeTabsHandler);
  }
);

